module.exports = __webpack_public_path__ + "static/media/ic_electro.6e0ea7fa.png";